import { MenuItem } from '@src/common/components/Menu';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = {
  order: OrderListing;
};
export const DuplicateAction = ({ order }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(OrdersNavigation.duplicate.url(order.id));
  };
  return (
    order.canDo(OrderActions.DUPLICATE_ORDER) && (
      <MenuItem key={`${order.id}-duplicate-order`} onClick={handleClick}>
        {t('duplicateOrder')}
      </MenuItem>
    )
  );
};
